import constants from '../../../ahm-constants';

export const INCLUDES_HOSPITAL = [
  constants.PRODUCT_TYPE.PACKAGE,
  constants.PRODUCT_TYPE.COMBINED,
  constants.PRODUCT_TYPE.HOSPITAL,
];
